<div class="col-xl">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="card-body">
        <div>
          <div class="container">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
                <li class="breadcrumb-item active"><a href="javascript:void(0)">Informazioni personali</a></li>
              </ol>
            </nav>
            <div class="row justify-content-center">
              <div class="col-12 col-lg-12">
                <h3 class="card-title h4" jhiTranslate="userInfo.informazioniPersonali">Informazioni personali</h3>
                <div class="card border-black border-top">
                </div>
              </div>
            </div>
            <div class="text-center justify-content-center d-flex">
              <div class="col-12 col-lg-8">
                <div class="card-body">
                  <div class="form-group">
                    <label for="inputNome" class="active" jhiTranslate="userInfo.nome">Nome</label>
                    <input id="inputNome" class="form-control fw-normal" type="text" value="{{userData.nome}}" readonly>
                  </div>
                  <div class="form-group">
                    <label for="inputCognome" class="active" jhiTranslate="userInfo.cognome">Cognome</label>
                    <input id="inputCognome" class="form-control fw-normal" type="text" value="{{userData.cognome}}"
                           readonly>
                  </div>
                  <div class="form-group">
                    <label for="inputMail" class="active" jhiTranslate="userInfo.eMail">E-mail</label>
                    <input id="inputMail" class="form-control fw-normal" type="text" value="{{userData.email}}"
                           readonly>
                  </div>
                  <div class="form-group">
                    <label for="inputTelefono" class="active" jhiTranslate="userInfo.numeroTelefono">Numero di
                      telefono</label>
                    <input id="inputTelefono" class="form-control fw-normal" type="text" value="{{userData.tel}}"
                           readonly>
                  </div>
                  <div class="form-group" *ngIf="account!.authorities[0] == 'ROLE_USER'">
                    <label for="inputIndirizzo" class="active" jhiTranslate="userInfo.indirizzo">Indirizzo</label>
                    <input id="inputIndirizzo" class="form-control fw-normal" type="text"
                           value="{{userData.indirizzo}}"
                           readonly>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <!--
  <div class="it-example-modal">
    <div class="modal" tabindex="-1" role="dialog" id="modalPassword" aria-labelledby="modalPasswordTitle"
      aria-describedby="modalPasswordDescription">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title h5 no_toc" id="modalPasswordTitle">Modifica password</h2>
          </div>
          <div class="modal-body">
            <p id="modalPasswordDescription"></p>
            <div class="form-group">
              <label for="oldPassword">Vecchia Password</label>
              <input id="oldPassword" class="form-control fw-normal" type="password">
            </div>
            <div class="form-group">
              <label for="newPassword">Nuova Password</label>
              <input id="newPassword" class="form-control fw-normal" type="password">
            </div>
            <div class="form-group">
              <label for="confirmNewPassword">Conferma Password</label>
              <input id="confirmNewPassword" class="form-control fw-normal" type="password">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-primary btn-sm" type="button" data-bs-dismiss="modal">Annulla</button>
            <button class="btn btn-primary btn-sm" type="button" data-bs-dismiss="modal"
              (click)="saveFieldData()">Conferma</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->
